import AclName from '../../acl/AclName';
import model from '../../models-v2/crm/basic-price-list/template-basic-price-list';

const path = '/admin/price-lists';

export default [
  {
    path,
    name: 'admin-price-lists',
    components: {
      default: () => import('../../pages/data-grid.vue'),
      topRightSection: () => import('../../views/pages/admin/PriceLists/TemplatePriceListsTopRightSection.vue'),
    },
    meta: {
      acl: AclName.SettingsPagePriceListsList,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Cenniki', url: path },
      ],
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
];
